import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getItemStepz } from 'src/helpers/localstorage'
import { loadPolizasByIdentificacion } from 'src/reducer/action/poliza'
import StepProgressBarCommon from '../../common/StepProgressBarCommon'
import FormaPago from './2-formapago/FormaPago'
import Pagar from './3-pagar/Pagar'
import ConfirmacionPago from './4-confirmacionpago/ConfirmacionPago'
import { useSearchParams } from 'react-router-dom'
import SeleccionePago from './1-seleccionepoliza'

export const PagoConID = ({ identificacion }) => {
  const dispatch = useDispatch()
  const { loadingPolizas } = useSelector(state => state.poliza)
  let [query] = useSearchParams();
  const estadoPoliza = query.get('EstadoPoliza')
  const razonCancelacion = query.get('RazonCancelacion')

  const steps = [
    {
      id: 1,
      label: 'Seleccione su poliza',
      // component: <SeleccionePago />,
      component : <SeleccionePago/>,
      subtitle: '50%',
      name: 'paso 1'
    },
    {
      id: 2,
      label: 'Forma de pago',
      component: <FormaPago />,
      subtitle: '50%',
      name: 'paso 2'
    },
    {
      id: 3,
      label: 'Pagar',
      component: <Pagar />,
      subtitle: '50%',
      name: 'paso 3'
    },
    {
      id: 4,
      label: 'Confirmación de pago',
      component: <ConfirmacionPago />,
      subtitle: '100%',
      name: 'paso 4'
    }
  ]

  useEffect(() => {
    // console.log(estadoPoliza);
    dispatch(loadPolizasByIdentificacion(identificacion, estadoPoliza, razonCancelacion))
  }, [dispatch, estadoPoliza, razonCancelacion]);

  // loading de dato de polizas
  // if (loadingPolizas) {
  //   return <p>Caargando..</p>
  // }

  return (
    <React.Fragment>
      <StepProgressBarCommon
        loading={loadingPolizas}
        steps={steps}
        addpropscomponent={{ identificacion }}
        stepStorage={getItemStepz()?.step}
      />
    </React.Fragment>
  )
}
